namespace SolovisGateway.Admin.Organizations {

    export class OrganizationEditorControl extends Solovis.UI.BaseControl {

        private _organizationId;
        private _isDirty
        private _isHidingUI: boolean;
        private _initErrorText;
        private _organizationEditModel;
        private _environmentPools;
        private _passwordPolicyCodes;

        private _formBuilder;

        private _savedOrganizationEditorModel;

        constructor(options) {
            super(options);

            this._organizationId = options.organizationId ? options.organizationId : null;
            this._isHidingUI = options.isHidingUI ? true : false;
            this._isDirty = false;
        }

        public doInitAsync() {
            var self = this;

            Solovis.Rpc.invoke("~/Admin/OrganizationAdmin/GetEditOrganizationDialogInitialState",
                { id: this._organizationId },
                function (response, success) {

                    if (success) {
                        if (!response.result.organizationEditModel) {
                            self._initErrorText = "Failed to retrieve environment pool edit model.";
                        }
                        else {
                            self._organizationEditModel = response.result.organizationEditModel;
                            self._environmentPools = response.result.environmentPools ? response.result.environmentPools : [];
                            self._passwordPolicyCodes = response.result.passwordPolicyCodes;
                        }
                        self.notifyInitComplete();
                    }
                    else {
                        self._initErrorText = response.error.message;
                        self.notifyInitComplete();
                    }
                });
        }

        public doDestroy() {
        }

        public doRender() {
            var self = this;

            this.container
                .addClass("value-editor");

            if (this._initErrorText) {
                this.container.text(this._initErrorText);
                return;
            }

            var formDiv = $("<div>").appendTo(this.container);
            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            // Name
            formBuilder.addEntry({
                name: "name",
                label: "Name",

                initialValue: this._organizationEditModel.name ? this._organizationEditModel.name : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        required: true,
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        readonly: self._isHidingUI,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // eVestment Id
            formBuilder.addEntry({
                name: "evestmentFirmId",
                label: "eVestment Firm ID",

                initialValue: this._organizationEditModel.evestmentFirmId ? this._organizationEditModel.evestmentFirmId : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        readonly: true,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                },
                postSetup: function (formEntry) {
                    formEntry.showEntry(self._isHidingUI);
                }
            });

            // Organization Code
            formBuilder.addEntry({
                name: "organizationCode",
                label: "Organization Code",

                initialValue: this._organizationEditModel.organizationCode ? this._organizationEditModel.organizationCode : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Default Database Host Connection String
            formBuilder.addEntry({
                name: "defaultDatabaseHostConnectionString",
                label: "Default Database Host Connection String",

                initialValue: this._organizationEditModel.defaultDatabaseHostConnectionString ? this._organizationEditModel.defaultDatabaseHostConnectionString : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl({
                        container: createEditorOptions.container,
                        width: 400,
                        rows: 3,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        cssRules: {
                            "resize": "both"
                        }
                    });

                    return editorControl;
                }
            });

            // Default Environment Pool
            formBuilder.addEntry({
                name: "defaultEnvironmentPool",
                label: "Default Environment Pool",

                initialValue: this._organizationEditModel.defaultEnvironmentPoolId ? this._organizationEditModel.defaultEnvironmentPoolId : null,

                createEditor: function (createEditorOptions) {
                    var environmentPoolOptions = [{ text: "", value: null }];

                    if (self._environmentPools.length) {
                        $(self._environmentPools).each(function (i, envPool: any) {
                            environmentPoolOptions.push({
                                text: envPool.name,
                                value: envPool.id
                            });
                        });
                    }

                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "select",
                        data: environmentPoolOptions,
                        value: createEditorOptions.initialValue
                    });

                    return editorControl;
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(self._environmentPools.length > 0);
                }
            });

            formBuilder.addEntry({
                name: "requireMfa",
                label: "Require Multi-Factor Authentication",

                initialValue: !!this._organizationEditModel.requireMfa,

                editor: {
                    type: "bool"
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            });

            formBuilder.addEntry({
                name: "mfaBypassIP",
                label: "MFA Bypass IP",

                initialValue: this._organizationEditModel.mfaBypassIP,

                editor: {
                    type: "text"
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            });

            let passwordPolicyOptions = [];
            passwordPolicyOptions.push({ text: "Default", value: "Default" });
            for (let code of this._passwordPolicyCodes) {
                passwordPolicyOptions.push({ text: code, value: code });
            }

            formBuilder.addEntry({
                name: "passwordPolicy",
                label: "Password Policy",

                initialValue: this._organizationEditModel.passwordPolicy ? this._organizationEditModel.passwordPolicy : "Default",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: passwordPolicyOptions
                    }
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            });


            formBuilder.addEntry({
                isGroupHeader: true,
                name: "authCookieGroup",
                label: "Authentication Cookie",

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            });

            // Allow Sliding Expiration

            let setupDefaultYesNo = (entryOptions: Solovis.UI.InputControls.FormEntryOptions, initialValue) => {
                let defaultYesNoOptions = [];
                defaultYesNoOptions.push({ text: "Default", value: "Default" });
                defaultYesNoOptions.push({ text: "Yes", value: "Yes" });
                defaultYesNoOptions.push({ text: "No", value: "No" });

                entryOptions.editor = {
                    type: "select",
                    selectOptions: {
                        data: defaultYesNoOptions
                    }
                };

                if (Solovis.isNotNull(initialValue)) {
                    entryOptions.initialValue = initialValue ? "Yes" : "No";
                }
                else {
                    entryOptions.initialValue = "Default";
                }
            };

            let allowSlidingExpirationEntryOptions = {
                name: "allowSlidingExpiration",
                label: "Allow Sliding Expiration",

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            };

            setupDefaultYesNo(allowSlidingExpirationEntryOptions, this._organizationEditModel.allowSlidingExpiration);

            formBuilder.addEntry(allowSlidingExpirationEntryOptions);

            // Auth Cookie Timeout Minutes

            formBuilder.addEntry({
                name: "authCookieTimeoutMinutes",
                label: "Timeout (Minutes)",

                initialValue: this._organizationEditModel.authCookieTimeoutMinutes,

                editor: {
                    type: "integer"
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            });

            // Persistent Cookie

            let persistentCookieEntryOptions = {
                name: "persistentCookie",
                label: "Persistent Cookie",

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            };

            setupDefaultYesNo(persistentCookieEntryOptions, this._organizationEditModel.persistentCookie);

            formBuilder.addEntry(persistentCookieEntryOptions);


            // Lock Cookie To Login IP
            let lockCookieToLoginIPEntryOptions = {
                name: "lockCookieToLoginIP",
                label: "Lock Cookie To Login IP",

                help: {
                    html: "<p>If enabled, the authentication cookie may only be used from the original IP address from which it was acquired.</p>"
                        + "<p>WARNING: This option is incompatible with enviornments where users' outgoing IP address is not stable (i.e."
                        + " such as mobile user switching between cellular and wi-fi connections).</p>"
                },
                
                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            };

            setupDefaultYesNo(lockCookieToLoginIPEntryOptions, this._organizationEditModel.lockCookieToLoginIP);


            formBuilder.addEntry(lockCookieToLoginIPEntryOptions);


            formBuilder.addEntry({
                name: "allowedLoginIP",
                label: "Allowed Login IP",

                help: {
                    html: "<p>If set, this will restrict the IP addresses from which interactive logins may be initiated or from which auth cookies may be renewed.</p>"
                        + "<p>Max Length: 512</p>"
                        + "<p>Uses same format as 'MFA Bypass IP' for range of IPs.</p>"
                },

                initialValue: this._organizationEditModel.allowedLoginIP,

                editor: {
                    type: "text",
                    textOptions: {
                        maxLength: 512
                    }
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(!self._isHidingUI);
                }
            });
            formBuilder.setupDone();

            $(formBuilder).bind("valueChanged", function () {
                self._isDirty = true;
            });

            this._formBuilder = formBuilder;
        }

        public _getOrganizationModel() {
            let name = this._formBuilder.getValueByName("name");
            let organizationCode = this._formBuilder.getValueByName("organizationCode");
            let defaultDatabaseHostConnectionString = this._formBuilder.getValueByName("defaultDatabaseHostConnectionString");
            let defaultEnvironmentPool = this._formBuilder.getValueByName("defaultEnvironmentPool");
            let evestmentFirmId = this._formBuilder.getValueByName("evestmentFirmId");
            let requireMfa = this._formBuilder.getValueByName("requireMfa");

            let mfaBypassIP = this._formBuilder.getValueByName("mfaBypassIP");
            let passwordPolicy = this._formBuilder.getValueByName("passwordPolicy");

            let getDefaultYesNoValue = (valueName) => {
                let valueOption = this._formBuilder.getValueByName(valueName);
                let value = null;
                if (valueOption === "Yes") {
                    value = true;
                }
                else if (valueOption === "No") {
                    value = false;
                }
                return value;
            };

            let allowSlidingExpiration = getDefaultYesNoValue("allowSlidingExpiration");

            let authCookieTimeoutMinutes = this._formBuilder.getValueByName("authCookieTimeoutMinutes");

            let persistentCookie = getDefaultYesNoValue("persistentCookie");

            let lockCookieToLoginIP = getDefaultYesNoValue("lockCookieToLoginIP");
            let allowedLoginIP = this._formBuilder.getValueByName("allowedLoginIP");

            let model = {
                name: name,
                organizationCode: organizationCode,
                defaultDatabaseHostConnectionString: defaultDatabaseHostConnectionString,
                defaultEnvironmentPoolId: defaultEnvironmentPool,
                organizationId: this._organizationId,
                requireMfa: requireMfa,
                mfaBypassIP: mfaBypassIP ? mfaBypassIP : null,
                passwordPolicy: (passwordPolicy && passwordPolicy != "Default") ? passwordPolicy : null,
                allowSlidingExpiration: allowSlidingExpiration,
                authCookieTimeoutMinutes: authCookieTimeoutMinutes ? authCookieTimeoutMinutes : null,
                persistentCookie: persistentCookie,
                lockCookieToLoginIP: lockCookieToLoginIP,
                allowedLoginIP: allowedLoginIP ? allowedLoginIP : null,
                evestmentFirmId: evestmentFirmId ? evestmentFirmId : null
            };

            return model;
        }

        public hideEditFields() {
            this._formBuilder.showEntries(false);
        }

        /*
         * options:
         * success -    true or false
         *              If success is true, this function assumes that a property called _savedDataEnvironmentEditorModel
         *              was set.  _savedDataEnvironmentEditorModel should contain the modelResult of the serverside save call.
         *              If success is false, then an error message should be provided.
         * message -    Error message to display on the form.
         */
        public notify(options) {
            var self = this;

            if (options.success) {

                this.hideEditFields();

                var successHtml = $("<div>");

                var name = this._formBuilder.getValueByName("name");

                var organizationLink = $("<a>")
                    .text(name)
                    .attr("href", Solovis.resolveUrl("~/Admin/OrganizationAdmin/Info?organizationId=" + this._savedOrganizationEditorModel.organizationId))
                    .appendTo(successHtml);

                successHtml
                    .prepend("Organization ")
                    .append(" saved.");

                var state = {
                    success: {
                        html: successHtml
                    }
                };

                this._formBuilder.formValidationModel.state(state);
            }
            else {
                this._formBuilder.formValidationModel.setErrorMessage(options.message);
            }
        }


        public isDirty() {
            return this._isDirty;
        }

        public isValid() {
            return !this._formBuilder.hasErrors();
        }
    }
}
